export default __webpack_public_path__ + "static/media/att.c0197a8f.svg";